function safeInvoke(callback) {
  if (callback != null) {
    callback();
  }
}
/**
 * Preloads the image in the specified URL.
 * Unless the returned image element is mounted on the DOM, its
 * dimensions will be updated based on the results of the preloaded
 * image.
 * @param url The URL from which to load the image.
 * @param options
 */


export default function loadImage(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$crossOrigin = options.crossOrigin,
      crossOrigin = _options$crossOrigin === void 0 ? null : _options$crossOrigin,
      onAbort = options.onAbort,
      onError = options.onError,
      onLoad = options.onLoad;
  var element = document.createElement('img');
  var image = new Image();

  function setDimension() {
    if (image != null && !element.parentNode) {
      element.width = image.width;
      element.height = image.height;
    }
  }

  function destroyImage() {
    if (image != null) {
      image.onabort = null;
      image.onerror = null;
      image.onload = null;
      image = null;
    }
  }

  function handleAbort() {
    if (image != null) {
      setDimension();
      destroyImage();
      safeInvoke(onAbort);
    }
  }

  function handleError() {
    if (image != null) {
      setDimension();
      destroyImage();
      safeInvoke(onError);
    }
  }

  function handleLoad() {
    if (image != null) {
      setDimension();
      destroyImage();
      safeInvoke(onLoad);
    }
  }

  image.onabort = handleAbort;
  image.onerror = handleError;
  image.onload = handleLoad;
  image.crossOrigin = crossOrigin;
  image.src = url;
  element.src = url;
  element.crossOrigin = crossOrigin;

  if (image && image.complete) {
    handleLoad();
  }

  return element;
}
//# sourceMappingURL=loadImage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/loadImage.js
// module id = 576
// module chunks = 0 1